import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static identifier = "worker-search"
    static targets = ["input", "preview"]
  static values = { url: String }

  connect() {
    this.timeout = null
  }

  search() {
    clearTimeout(this.timeout)
    
    const query = this.inputTarget.value.trim()
    
    if (query.length === 0) {
      this.previewTarget.innerHTML = '<span class="search-hint">Leave blank to send to all workers</span>'
      return
    }
    
    if (query.length < 2) {
      this.previewTarget.innerHTML = '<span class="search-hint">Type at least 2 characters to search</span>'
      return
    }

    this.previewTarget.innerHTML = '<span class="search-loading">Searching...</span>'
    
    this.timeout = setTimeout(() => {
      this.performSearch(query)
    }, 300)
  }

  async performSearch(query) {
    try {
      const endpoint = this.urlValue || '/admin/notifications/search_workers'
      const response = await fetch(`${endpoint}?q=${encodeURIComponent(query)}`)
      const data = await response.json()
      
      if (data.workers && data.workers.length > 0) {
        const workersHtml = data.workers.map(worker => 
          `<div class="search-result">
            <strong>${worker.name}</strong> (ID: ${worker.id})
          </div>`
        ).join('')
        
        this.previewTarget.innerHTML = `
          <div class="search-results">
            <div class="search-header">Found ${data.workers.length} worker${data.workers.length !== 1 ? 's' : ''}:</div>
            ${workersHtml}
          </div>
        `
      } else {
        this.previewTarget.innerHTML = '<span class="search-no-results">No workers found</span>'
      }
    } catch (error) {
      this.previewTarget.innerHTML = '<span class="search-error">Search error occurred</span>'
    }
  }
}
